export enum QuestionType
{
    Checklist
    ,MultipleChoice
    ,Textbox
    ,SingleChoice
}


// WEBPACK FOOTER //
// ./src/app/shared/models/question-type.ts